import { createSelector } from 'reselect';

import type { MayBe } from 'modules/global/typing/common/common';
import type { RootState } from 'reducers/index';
import { getProps } from 'utils/selectors';

import type { Guideline, GuidelineByGuidelineIdState } from '../types';

export const getState = (state: RootState) => state.guidelines;

export const getByIdState = createSelector(getState, state => state.data.byId);

const getByGuidelineIdState = createSelector(getState, state => state.data.byGuidelineId);

const getLatestIdFromGuidelineId = (state: GuidelineByGuidelineIdState, guidelineId: string): MayBe<string> => {
  const dictionary = state?.[guidelineId];
  if (!dictionary) {
    return undefined;
  }
  const latestVersion = Math.max(...Object.values(dictionary));
  const [id] = Object.entries(dictionary).find(([, version]) => version === latestVersion) ?? [];
  return id;
};

export const getByGuidelineId = createSelector(
  getByIdState,
  getByGuidelineIdState,
  getProps<string>,
  (state, guidelineIdState, guidelineId) => {
    const id = getLatestIdFromGuidelineId(guidelineIdState, guidelineId);
    return id ? state?.[id] : undefined;
  }
);

export const getByGuidelineIds = createSelector(
  getByIdState,
  getByGuidelineIdState,
  getProps<string[]>,
  (state, guidelineIdState, guidelineIds) =>
    guidelineIds.reduce<Guideline[]>((acc, guidelineId) => {
      const id = getLatestIdFromGuidelineId(guidelineIdState, guidelineId);
      const guideline = id ? state?.[id] : undefined;
      if (guideline) {
        acc.push(guideline);
      }
      return acc;
    }, [])
);
